module.exports = __webpack_public_path__ + "img/thumb_15.c8fc6bcd.jpg";